module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{},"en":{}}')
  delete Component.options._Ctor
}
